import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from './index';

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  return (
    <TextField
      select
      size="small"
      label={t('common.language')}
      value={i18n.resolvedLanguage || 'en'}
      onChange={(event) => changeLanguage(event.target.value)}
      sx={{ minWidth: 140, maxWidth: '100%', my: 1 }}
    >
      <MenuItem value="ru" lang="ru">Русский</MenuItem>
      <MenuItem value="en" lang="en">English</MenuItem>
    </TextField>
  );
}
